import faultIcon from '@/assets/incidents-icons/fault-icon.svg'
import maintenanceIcon from '@/assets/incidents-icons/maintenance-icon.svg'
import { useCreateIncidentContext, useUserLanguage } from '@/customHooks'
import textsData from '@/textData/CreateIncidentTexts.json'
import { IncidentTypeOption } from '@/graphql/generated'
import { Col, Row } from 'react-grid-system'
import { NormalFormTextField, SquareButtonsCard } from '../molecules'
import { useEffect, useMemo } from 'react'
import styled from 'styled-components'

const FieldContainer = styled.div`
  background-color: white;
  border-radius: ${({ theme }) => theme.border.radius.lg};
  padding: 2rem;
  margin-bottom: 3rem;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  width: 400px;
`;

export const SelectIncidentTypeMenu = () => {
  const userLanguage = useUserLanguage();

  const texts = userLanguage === 'es' ? textsData.es.incidentType : textsData.en.incidentType

  const { state, setType, setSubject, setButtonEnabled, setButtonDisabled } = useCreateIncidentContext()

  const buttons = [
    { text: texts.button.button1, icon: faultIcon },
    { text: texts.button.button2, icon: maintenanceIcon },
  ];

  const defaultSelectedIndex = useMemo(() => {
    if (state.incidentType === IncidentTypeOption.Fault) return 0;
    if (state.incidentType === IncidentTypeOption.Maintenance) return 1;
    return null;
  }, [state.incidentType]);

  useEffect(() => {
    if (state.incidentType && state.subject && state.subject.trim() !== '') {
      setButtonEnabled();
    } else {
      setButtonDisabled();
    }
  }, [state.incidentType, state.subject, setButtonEnabled, setButtonDisabled]);

  const onSelectedHandle = (value: number | null) => {
    switch (value) {
      case 0:
        setType(IncidentTypeOption.Fault)
        break
      case 1:
        setType(IncidentTypeOption.Maintenance)
        break
      
      default:
        throw new Error('Select value for IncidentType is invalid [SelectIncidentTypeMenuCard]')
    }
  }
  
  return (
    <>
      <Row justify="center">
        <Col xs='content'>
          <FieldContainer>
            <NormalFormTextField
              label={texts.subjectField.label}
              placeholder={texts.subjectField.placeholder}
              value={state.subject}
              required
              onChange={(value) => setSubject(value)}
            />
          </FieldContainer>
        </Col>
      </Row>
      <Row justify="center">
        <Col xs='content'>
          <SquareButtonsCard
            buttons={buttons}
            onSelected={onSelectedHandle}
            defaultSelected={defaultSelectedIndex}
          />
        </Col>
      </Row>
    </>
  );
}